import React from 'react';
import './css/parking-allot.css';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Layout } from 'antd';
import Sidebar from '../Layout/Sidebar';
import { dataUser, dataLocation } from './..//Helpers/util';
import { toast } from 'react-toastify';
import ParkingReqFilterNew from './parkingReqFilterNew';
import ParkingReqSortNew from './parkingReqSortNew';
import MarketingPanel from '../MarketingPanel';
import { getServiceAccess } from '../../Redux/action/userActions';
import axiosInstance from '../../utils/axiosInstance';
import mixpanel from 'mixpanel-browser';
import ParkingViewNew from './ParkingViewNew';

import Select, { components } from 'react-select';
import DropdownArrowDown from './img/dropdownArrow-Down.svg';
import DropdownCloseIcon from './img/close-icon.svg';
import moment from 'moment';
import { Navigate } from 'react-router-dom';
import CustomHeader from '../Layout/Header';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwKpiGroup from '../Common/SwKPI/SwKpiGroup';
import SwKpi from '../Common/SwKPI/SwKPI';
import SwInput from '../Common/FormComponent/SwInput';
import AntDTable from '../Common/AntDTable/AntDTable';
import SwButton from '../Common/SwButtons/SwButtons';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import SwModal from '../Common/SwModal/SwModal';
import SwNoData from '../Common/NoData/NoData';
import SwLoader from '../Common/SwLoader/SwLoader';

const apiURL = require('./../../constant');
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
let article = {
  company_id: UserObj ? UserObj.company_id : 202,
  offset: 0,
  limit: 25,
  search: '',
  location_id: [],
};
let articleCopy = article;

function ParkSmart() {
  const [availableLocations, setAvailableLocations] = useState([]);
  const [vehicleData, setVehicleData] = useState({
    name: '',
    email: '',
    phone: '',
    vehicleNumber: '',
    vehicleType: '',
    rec_id: '',
  });
  const [tagOptions, setTagOptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [parkingProviders, setParkingProviders] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [ParkingUser, setParkingUser] = useState([]);
  const [ParkingCount, setParkingCount] = useState([]);
  const [RequestId, setRequestId] = useState(0);
  const [RequestText, setRequestText] = useState('');
  const [RequestStatus, setRequestStatus] = useState('');
  const [TagId, setTagId] = useState('');
  const [tagRfId, setTagRfId] = useState('');
  const [VehicleNumber, setVehicleNumber] = useState('');
  const [FilterData, setFilterData] = useState({});
  const [SortData, setSortData] = useState('');
  const [Row, setRowData] = useState('25');
  const [PageNo, setPageNoData] = useState(1);
  const [bg, changeBGColor] = useState(0);
  const [accessServiceLists, setAccessServiceLists] = useState([]);
  const [loaderServiceAccess, setLoaderServiceAccess] = useState(true);
  const [rowDatas, setRowDatas] = useState(null);
  const [location, setLocation] = useState([{ value: '', label: 'Select' }]);
  const [selectedLocations, setSelectedLocations] = useState(
    sessionStorage.getItem('selectedLocations')
      ? JSON.parse(sessionStorage.getItem('selectedLocations'))
      : [],
  );
  const [selectedLocation, setSelectedLocation] = useState(
    sessionStorage.getItem('selectedLocation')
      ? JSON.parse(sessionStorage.getItem('selectedLocation'))
      : null,
  );
  const [selectedLocationIds, setSelectedLocationIds] = useState([]);

  const [ssoLoginUrl, setSsoLoginUrl] = useState('');
  const [alertMsg, setAlertMsg] = useState('');
  const [issueTagLogin, setIssueTagLogin] = useState('');
  const [shouldNavigate, setShouldNavigate] = useState(false);
  const [navigateTo, setNavigateTo] = useState('');
  const navigate = useNavigate();

  const [selectedOption, setSelectedOption] = useState(null);
  const [isVehicleDrawerOpen, setIsVehicleDrawerOpen] = useState(false);
  const [changeStatusModalOpen, setChangeStatusModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);


  const headers = [
    { label: 'Id', key: 'rec_id' },
    { label: 'Email', key: 'email' },
    { label: 'Phone', key: 'phone' },
    { label: 'Status', key: 'status' },
    { label: 'User Id', key: 'user_id' },
    { label: 'User Name', key: 'user_name' },
    { label: 'Vehicle Number', key: 'vehicle_number' },
    { label: 'Vehicle RC', key: 'vehicle_rc' },
    { label: 'Vehicle Wheelers', key: 'wheeler' },
  ];

  const parkingView = () => {
    mixpanel.track('Parking View', {
      PageName: 'Parking',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Parking',
    });
  };

  // Popup Modal
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [parkingData, setParkingData] = useState({
    users: [],
    counts: {},
    provider: '',
    location: null,
    locationId: null,
  });

  const updateParkingData = data => {
    setParkingData(prev => ({
      ...prev,
      ...data,
    }));
    // Store in session for persistence
    sessionStorage.setItem(
      'parkingData',
      JSON.stringify({
        ...parkingData,
        ...data,
      }),
    );
  };

  const changeListStatus = async type => {
    changeBGColor(type);

    if (type > 0 && type < 8) {
      article.status = type;
    } else {
      article.status = false;
    }

    await fetchParkingData(article);
  };

  const filterListing = async e => {
    if (e.key === 'Enter') {
      article.search = e.target.value;
      article.offset = 0;
      article.limit = 25;

      await fetchParkingData(article);
    }
  };

  const fillStatus = async (id, status, tag_id, vehicle_number, rfid) => {
    let alertText = 'Are you sure you want to approve this request ?';
    if (status == 6) {
      alertText = 'Are you sure you want to reject this request ?';
    } else if (status == 5) {
      alertText = 'Are you sure you want to delete this request ?';
    }
    setRequestId(id);
    setRequestText(alertText);
    setRequestStatus(status);
    setTagId(tag_id);
    setTagRfId(rfid);
    setVehicleNumber(vehicle_number);
  };

  const changeStatus = async (id, status, tag_id) => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      // Prepare the data to be sent in the POST request
      let dataAry = {
        rec_id: id,
        status: status,
        spoc_name: `${UserObj.fname} ${UserObj.lname}`,
        comp_name: UserObj.company_name,
        tag_id: tag_id,
        rfid_tag_id: vehicleData.tagId,
      };

      // First POST request: change the status
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parkplus_statusv2`,
        dataAry,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );

      // If the response status is 200, handle the result
      if (response.status === 200) {
        if (status === 2) {
          toast.success('Request Approved Successfully', {});
        } else if (status === 6) {
          toast.info('Request Rejected Successfully', {});
        } else {
          toast.warn('Request Deleted Successfully', {});
        }
        setTimeout(() => {
          window.location.reload();
        }, 1000);

        // Update article status and make the second API call for count
        let articleStatus = article.status;
        article.status = false;

        const countResponse = await axiosInstance.post(
          `${
            process.env.REACT_APP_API_GATEWAYS_URL
          }cspoc/api/v1/parking/parkplus_countv2`,
          article,
          {
            headers: {
              Authorization: authToken?.spintlyToken,
            },
          },
        );

        setParkingCount(countResponse.data.data);

        // Change list status if needed
        changeListStatus(articleStatus);
      }
    } catch (error) {
      // Log any error that occurs
      console.error('Error changing status:', error.response?.body || error);
    }
  };

  const changeListNum = async num => {
    article.limit = num;
    await fetchParkingData(article);
    sessionStorage.setItem('parkingData', JSON.stringify(parkingData));
  };

  const previousPage = async num => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      // Set the offset and location_id for the request
      article.offset = num;
      article.location_id = selectedLocations?.map(item =>
        item.value.toString(),
      );

      // Await the API request to get parking request data
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parking_requestv2`,
        article,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );

      // Set the parking user data from the response
      setParkingUser(response.data.data);

      // Call setData() if necessary
      setData();
    } catch (error) {
      // Handle any error that occurs during the request
      console.error(
        'Error fetching parking request data:',
        error.response?.body || error,
      );
    }
  };
  const nextPage = async num => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      // Set the offset and location_id for the request
      article.offset = num;
      article.location_id = selectedLocations?.map(item =>
        item.value.toString(),
      );

      // Await the API request to get parking request data
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parking_requestv2`,
        article,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );

      // Set the parking user data from the response
      setParkingUser(response.data.data);

      // Call setData() if necessary
      setData();
    } catch (error) {
      // Handle any error that occurs during the request
      console.error(
        'Error fetching parking request data:',
        error.response?.body || error,
      );
    }
  };

  let totalRec = ParkingCount.total;
  let ptype = [
    'total',
    'pending',
    'assigned',
    'approved',
    'deleted',
    'deleted_req',
    'rejected',
    'rejected_sw',
  ];
  if (article.status) {
    var typeVar = ptype[article.status];
    totalRec = ParkingCount[typeVar];
  }
  let count = parseInt(article.offset);
  //let totalRec = ParkingCount.total;

  let totalPage = Math.ceil(totalRec / article.limit);
  if (totalRec / article.limit > 0 && totalRec / article.limit < 1)
    totalPage = 1;
  let nextSet = parseInt(article.limit) + parseInt(count);
  let prevSet = count - article.limit;
  let pgno = parseInt(nextSet / article.limit);
  let lastPage = totalPage - pgno;
  let next = parseInt(totalRec - article.limit * pgno);
  let forward = 'Disabled';
  let backward = 'Disabled';

  async function setData() {
    count = parseInt(article.offset);
    totalRec = ParkingCount.total;
    totalPage = Math.ceil(totalRec / article.limit);
    if (totalRec / article.limit > 0 && totalRec / article.limit < 1)
      totalPage = 1;
    nextSet = parseInt(article.limit) + parseInt(count);
    prevSet = count - article.limit;
    pgno = parseInt(nextSet / article.limit);
    next = parseInt(totalRec - article.limit * pgno);
    lastPage = totalPage - pgno;
  }

  if (next > 0) {
    forward = '';
  }

  if (pgno > 1) {
    backward = '';
  }

  // const clearSearchBox = () => {
  // 	// this.setState({ searchText: "" });
  // }

  const handleLanguage = langValue => {
    setFilterData(langValue);
  };

  const shortSelectData = shortallkey => {
    setSortData(shortallkey);
  };

  useEffect(() => {
    fetchServiceAccess();
    parkingView();
  }, []);

  const fetchServiceAccess = async () => {
    const getCompanyId = UserObj.company_id;
    const response = await getServiceAccess(getCompanyId);
    setAccessServiceLists(response);
    setLoaderServiceAccess(false);
  };

  const childCallback = async value => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    // If value is null, reset the article to its original copy
    if (value == null) {
      article = articleCopy;
    } else {
      article = {
        ...article,
        ...value,
      };
    }

    try {
      // Set the location_id for the article
      article.location_id = selectedLocations?.map(item =>
        item.value.toString(),
      );

      // First API call for parking request
      const parkingResponse = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parking_requestv2`,
        article,
        {},
      );
      setParkingUser(parkingResponse.data.data);

      // Second API call for parkplus count
      const parkingCountResponse = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parkplus_countv2`,
        article,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );
      setParkingCount(parkingCountResponse.data.data);
    } catch (e) {
      console.error('Error during API calls:', e);
    }
  };

  let serviceAccess = true;
  const serviceAccessId = 8;
  if (accessServiceLists.length > 0) {
    let serviceAccessobject = {};
    accessServiceLists.map(e => {
      if (e.id == serviceAccessId) serviceAccessobject = e;
    });
    serviceAccess = false;
    if (serviceAccessobject) serviceAccess = serviceAccessobject.service_access;
  }

  const handleRowClick = data => {
    setRowDatas(data);
  };

  /*Start Code for multiselect locations based on spoc */

  useEffect(() => {
    let authToken = JSON.parse(localStorage.getItem('headData'));
    const params = {
      params: { spoc: UserObj.rec_id, client: UserObj.company_id },
      headers: {
        Authorization: authToken?.spintlyToken,
      },
    };
    axios
      .get(
        `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
        params,
      )
      .then(res => {
        if (res.data.status == 'success') {
          setLocation(res.data.data);
        }
      })
      .catch(err => {
        console.log('err', err);
      });
  }, []);

  const LocationData = [];
  location.map(item =>
    LocationData.push({ value: item?.rec_id, label: item.location_name }),
  );

  useEffect(() => {
    let filter = {};
    if (selectedLocationIds?.length > 0) {
      filter.location = selectedLocationIds;
      if (selectedLocations.length > 0) {
        childCallback();
      }
    }
  }, [selectedLocationIds]);

  useEffect(() => {
    let filter = {};
    if (selectedLocationIds?.length > 0) {
      filter.location = selectedLocationIds;
      if (selectedLocations.length > 0) {
        childCallback();
      }
    }
  }, [selectedLocationIds]);
  const fetchParkingProvider = async (locationId, articleData) => {
    try {
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/get_parking_provider`,
        { locationId },
      );

      if (response.data.status === 'success') {
        const provider = response.data.data;
        setParkingProviders(provider);

        if (provider === 'PARK_SMART') {
          setNavigateTo('/park-smart');
          setShouldNavigate(true);
        } else if (provider === 'PARK_PLUS') {
          await fetchParkingData(articleData); // pass correct article data
          setNavigateTo('/park-plus');
          setShouldNavigate(true);
        }
      } else {
        console.warn('No providers found');
      }
    } catch (error) {
      console.error('Error fetching parking provider:', error);
    }
  };

  const fetchParkingData = async articleData => {
    try {
      const authToken = JSON.parse(localStorage.getItem('headData'));

      const [countResponse, requestResponse] = await Promise.all([
        axiosInstance.post(
          `${
            process.env.REACT_APP_API_GATEWAYS_URL
          }cspoc/api/v1/parking/parkplus_countv2`,
          articleData,
          {
            headers: { Authorization: authToken?.spintlyToken },
          },
        ),
        axiosInstance.post(
          `${
            process.env.REACT_APP_API_GATEWAYS_URL
          }cspoc/api/v1/parking/parking_requestv2`,
          articleData,
        ),
      ]);

      const newData = {
        users: requestResponse.data.data,
        counts: countResponse.data.data,
        provider: parkingProviders,
      };

      // Update all states at once
      updateParkingData(newData);
      setParkingUser(requestResponse.data.data);
      setParkingCount(countResponse.data.data);

      await setData();
    } catch (error) {
      console.error('Error fetching parking data:', error);
    }
  };

  function onLocationChange(location) {
    if (location) {
      const locationValue = location.value.toString();

      // Update all location related states
      setSelectedLocation(location);
      setSelectedLocationIds([locationValue]);
      setSelectedLocations([location]);

      // Store location in session storage
      sessionStorage.setItem('selectedLocation', JSON.stringify(location));
      sessionStorage.setItem('selectedLocationId', locationValue);

      // Update parkingData with location info
      updateParkingData({
        location: location,
        locationId: locationValue,
      });

      // Update article and fetch data
      const updatedArticle = { ...article, location_id: [locationValue] };
      fetchParkingProvider(locationValue, updatedArticle);
    } else {
      // Clear all states when location is deselected
      setSelectedLocation(null);
      setSelectedLocationIds([]);
      setSelectedLocations([]);
      setParkingUser([]);
      setParkingCount([]);

      // Clear storage
      sessionStorage.removeItem('selectedLocation');
      sessionStorage.removeItem('selectedLocationId');
      sessionStorage.removeItem('parkingData');

      article.location_id = [];
    }
  }
  useEffect(() => {
    // Load saved parking data
    const savedParkingData = sessionStorage.getItem('parkingData');
    const savedLocation = sessionStorage.getItem('selectedLocation');
    const savedLocationId = sessionStorage.getItem('selectedLocationId');

    if (savedLocation && savedLocationId) {
      const parsedLocation = JSON.parse(savedLocation);

      // Restore location states
      setSelectedLocation(parsedLocation);
      setSelectedLocationIds([savedLocationId]);
      setSelectedLocations([parsedLocation]);

      // Update article with location
      article.location_id = [savedLocationId];

      // Fetch parking provider and data
      fetchParkingProvider(savedLocationId, article);
    } else {
      // Clear states if no saved location
      setSelectedLocation(null);
      setSelectedLocationIds([]);
      setSelectedLocations([]);
      setParkingUser([]);
      setParkingCount([]);
      article.location_id = [];
    }
  }, []);

  useEffect(() => {
    if (shouldNavigate && navigateTo) {
      // Store current state before navigation
      sessionStorage.setItem('parkingData', JSON.stringify(parkingData));
      navigate(navigateTo);
      setShouldNavigate(false);
    }
  }, [shouldNavigate, navigateTo]);

  useEffect(() => {
    if (location && location.length > 0) {
      const selectLocationData = location.map(item => ({
        value: item['rec_id'],
        label: item['location_name'],
      }));

      setAvailableLocations(selectLocationData); // A state for populating dropdown
    }
  }, [location]);

  /*End Code for multiselect locations based on spoc */

  const ssoParkPlusLogin1 = async () => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      let dataAry = {
        companyId: UserObj?.company_id,
      };

      // Use await instead of .then()
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parkplus_login`,
        dataAry,
        {},
      );

      // Check the response status and update the state accordingly
      if (response.data.status === 200) {
        setSsoLoginUrl(response.data.data);
      } else if (response.data.status === 400) {
        setAlertMsg(response.data.status);
      }
    } catch (error) {
      // Log the error in case of failure
      console.error('Error during the API call:', error);
    }
  };

  const ssoParkPlusLogin = async () => {
    try {
      let dataAry = {
        companyId: UserObj?.company_id,
      };

      // Use await instead of .then()
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parkplus_bulk_assign`,
        dataAry,
        {},
      );

      // Check the response status and update the state accordingly
      if (response.data.status === 200) {
        setSsoLoginUrl(response.data.data);
      } else if (response.data.status === 400) {
        setAlertMsg(response.data.status);
      }
    } catch (error) {
      // Log the error in case of failure
      console.error('Error during the API call:', error);
    }
  };

  const openUrlInNewTab1 = () => {
    ssoParkPlusLogin1();
  };

  // Function to open URL in a new tab
  const openUrlInNewTab = () => {
    ssoParkPlusLogin();
  };

  useEffect(() => {
    if (ssoLoginUrl) {
      window.open(ssoLoginUrl, '_blank');
    }
  }, [ssoLoginUrl]);

  const issueTagButtonClick = async (
    vehicle_number,
    phone,
    wheeler,
    user_name,
    email,
  ) => {
    const params = {
      companyId: UserObj.company_id,
      vehicle_number,
      phone,
      wheeler,
      user_name,
      user_email: email,
    };

    try {
      // Await the response from the axios POST request
      const res = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parkplus_assign`,
        params,
        {},
      );

      // Handle the response based on the status
      if (res.data.status === 200) {
        setIssueTagLogin(res.data.data);
      } else if (res.data.status === 400) {
        toast.error(res.data.message, {});
      }
    } catch (error) {
      // Handle any errors that occur during the request
      console.error('Error during the API call:', error);
    }
  };

  useEffect(() => {
    if (issueTagLogin) {
      window.open(issueTagLogin, '_blank');
    }
  }, [issueTagLogin]);
  const toggleCollapsed = () => {
    setCollapsed(prevState => !prevState);
  };

  if (shouldNavigate && navigateTo) {
    return <Navigate to={navigateTo} replace />;
  }

  const deleteParkSmart = async tag_id => {
    try {
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parksmart_delete`,
        {
          tagId: TagId,
          rfid_tag_id: tagRfId,
        },
      );
      if (response.data.type === 'success') {
        toast.success(response.data.message || 'Tag activated successfully');
        // Close modal
      } else {
        toast.error(response.data.message || 'Something went wrong');
      }
      setTimeout(() => {
        window.location.reload();
      }, 1000);

  
      // Show toast or update UI as needed
    } catch (error) {
      console.error('Delete Failed:', error);
      // Show error message
    }
  };

  const fetchTagRfIds = async () => {
    try {
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/rfid_by_location`,
        {
          locationId: Number(selectedLocationIds[0]),
          companyId: UserObj.company_id,
        },
      );
      const tags = response.data?.data || [];
      const formattedTags = tags.map(tag => ({
        label: tag.tagId,
        value: tag.rfId,
        tagId: tag.tagId,
      }));
      setTagOptions(formattedTags);
    } catch (error) {
      console.error('Error fetching tag RFID list', error);
    }
  };

  const issueTagAssignSmart = async (
    vehicle_number, // items.vehicle_number
    wheeler, // items.wheeler
    requestId, // items.requestId or ''
    rec_id, // items.rec_id
    userName, // items.user_name
    email, // items.email
    phone,
  ) => {
    setVehicleData({
      name: userName,
      email: email,
      phone: phone,
      vehicleNumber: vehicle_number,
      vehicleType: wheeler,
      rec_id: rec_id,
    });

    fetchTagRfIds();
  };

  const handleVehicleSubmit = async () => {
    setIsSubmitting(true);

    if (vehicleData.vehicleType === '2' && !vehicleData.rfidTag) {
      toast.error('Tag RFID is required for Two Wheeler');
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parksmart_assign`,
        {
          requestId: vehicleData.rec_id,
          locationId: Number(selectedLocationIds[0]),
          companyId: UserObj.company_id,
          vehicle_number: vehicleData.vehicleNumber,
          wheeler: vehicleData.vehicleType,
          rfid: vehicleData.rfidTag,
          rfid_tag_id: vehicleData.tagId,
        },
      );

      if (response.data.type === 'success') {
        toast.success(response.data.message || 'Tag activated successfully');
      } else {
        toast.error(response.data.message || 'Something went wrong');
      }
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {

      const backendMessage = error?.response?.data?.message;

      if (error?.response?.status === 400) {
        // Show backend error message directly
        toast.error(backendMessage);
      } else {
        toast.error(
          backendMessage || 'Something went wrong while assigning tag',
        );
      }

      console.error('Assign Failed:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const options = [
    { value: 'Option 1', label: 'Option 1' },
    { value: 'Option 2', label: 'Option 2' },
    { value: 'Option 3', label: 'Option 3' },
    { value: 'Option 4', label: 'Option 4' },
    { value: 'Option 5', label: 'Option 5' },
  ];

  // Custom Dropdown Arrow
  const SwSelectArrow = props => {
    return (
      <components.DropdownIndicator {...props}>
        <img
          src={DropdownArrowDown}
          alt="Dropdown Arrow"
          width={10}
          className="SwSelect_DD_Arrow"
        />
      </components.DropdownIndicator>
    );
  };

  // Custom Clear Indicator (Close Icon)
  const SwClearIndicator = props => {
    return (
      <components.ClearIndicator {...props}>
        <img
          src={DropdownCloseIcon}
          alt="Clear"
          width={12}
          style={{ cursor: 'pointer' }}
        />
      </components.ClearIndicator>
    );
  };

  // SW Select Style
  const SwSelectStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#1E1E2D'
        : state.isFocused
        ? '#F4F4F5' // Light grey for focused (non-selected)
        : '#fff',
      color: state.isSelected ? '#fff' : '#000', // Optional: text color change when selected
      '&:hover': {
        backgroundColor: state.isSelected ? '#1E1E2D' : '#323242', // Darker hover if not selected
      },
    }),
  };
const columns = [
  {
    title: 'Location',
    dataIndex: 'location_name',
    key: 'location_name',
  },
  {
    title: 'Name',
    dataIndex: 'user_name',
    key: 'user_name',
  },
  {
    title: 'Phone No.',
    dataIndex: 'phone',
    key: 'phone',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Vehicle Number',
    dataIndex: 'vehicle_number',
    key: 'vehicle_number',
  },
  {
    title: 'Vehicle RC',
    key: 'vehicle_rc',
    render: (_, record) => (
      <SwButton
      size='sm'
      variant="dark-outline"
        className="SwBadge"
        onClick={() => {
          if (!record.vehicle_rc) {
            toast.warning('Vehicle RC is not available');
            return;
          }
          window.open(record.vehicle_rc, '_blank', 'noopener,noreferrer');
        }}
      >
        View
      </SwButton>
    ),
  },
  {
    title: 'Vehicle Type',
    noWrap: true,
    render: (_, record) => `${record.wheeler} Wheeler`,
  },
  {
    title: 'Tag',
    dataIndex: 'tag_id',
    key: 'tag_id',
  },
  {
    title: 'RFID Tag',
    dataIndex: 'rfid_tag_id',
    key: 'rfid_tag_id',
  },
  {
    title: 'Request Date and Time',
    noWrap: true,
    render: (_, record) =>
      moment(record.created_at)
        .utcOffset(0)
        .format('YYYY-MM-DD HH:mm:ss'),
  },
  {
    title: 'Status',
    render: (_, record) => {
      const statusMap = {
        Pending: <span className="SwLinkWarning">Pending</span>,
        Approved: <span className="SwLinkInfo">Whitelisted</span>,
        Rejected: <span className="SwLinkDanger">Rejected</span>,
        Deleted: <span className="ParkPlusStatus Deleted">Deleted</span>,
      };

      return statusMap[record.status] || null;
    },
  },
  {
    title: 'Action',
    render: (_, items) => {
      if (items.status === 'Pending') {
        return (
          <div className="d-flex Parkplus_Table_CTA_Column">
            <SwButton
            size='sm'
            variant="dark"
              className="SwBadge me-2"
              onClick={(e) => {
                e.stopPropagation();
                issueTagAssignSmart(
                  items.vehicle_number,
                  items.wheeler,
                  items.requestId,
                  items.rec_id,
                  items.user_name,
                  items.email,
                  items.phone
                );
                setIsVehicleDrawerOpen(true);
              }}
            >
              + Issue tag
            </SwButton>

            <SwButton
              size="sm"
              variant="danger-outline"
              className="SwBadge"
              onClick={(e) => {
                e.stopPropagation();
                fillStatus(items.rec_id, 6, 0, 0);
                setChangeStatusModalOpen(true);
              }}
            >
              Reject
            </SwButton>
          </div>
        );
      }

      if (items.status === 'Approved') {
        return (
          <SwButton
            size="sm"
            variant="danger"
            className="SwBadge"
            onClick={(e) => {
              e.stopPropagation();
              fillStatus(
                items.rec_id,
                5,
                items.tag_id,
                items.vehicle_number,
                items.rfid_tag_id
              );
              setDeleteModalOpen(true);
            }}
          >
            Delete
          </SwButton>
        );
      }

      return null;
    },
  },
];

  return (
    <>
      <Layout>
        <Sidebar collapsed={collapsed} />
        <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />

        <Layout
          className={
            collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'
          }
        >
          <div
            className="custome modal right fade"
            id="parkingRequestModal"
            data-backdrop="static"
          >
            {' '}
            {rowDatas && (
              <ParkingViewNew
                rowDatas={rowDatas}
                article={article}
                changeListStatus={changeListStatus}
              />
            )}
          </div>{' '}
          {serviceAccess === true ? (
            <>
              
              <div class="PageContent">
                <div className="row">
                  <div class="col-md-4">
                   <div className="SwHeading">
                      <h2>
                        Parking Management
                      </h2>
                    </div>
                  </div>
                  <div class="col-md-8">
                    <div class="PageHead_Optons_Row">
                      <ul className='PageHead_Optons_RightAligned'>
                        <li>
                          <div className="SwInputWithIcon">
                            <SwInput
                             placeholder="Search..."
                             onKeyPress={filterListing}
                            />
                            <span className="SwInputicon">
                             <i className="bi bi-search"></i>
                            </span>
                          </div>
                        </li>
                        <li>
                          <ParkingReqFilterNew
                            clearSearch={''}
                            sendFilterToParent={childCallback}
                          />
                        </li>
                        <li>
                          <ParkingReqSortNew
                            parkingInfo={ParkingUser}
                            sendSortToParent={childCallback}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="row align-items-end justify-content-between">
                  <div className="col-lg-3">
                    <div className="SwFormGroup">
                      <label className='SwFormLabel'>Location</label>
                      <SwSelect
                        placeholder="Select Location"
                        options={LocationData}
                        value={selectedLocation}
                        onChange={onLocationChange}
                        isClearable={false}
                      />
                    </div>
                  </div>

                  <div className="col-md-8" />

                </div>

                {selectedLocations.length > 0 ? (
                  <div class="row">
                    <div class="col-12">
                      <SwKpiGroup>
                        <SwKpi
                          label="Total Request"
                          value={ParkingCount?.total || 0}
                          active={bg === 9}
                          onClick={() => changeListStatus(9)}
                        />
                        <SwKpi
                          label="Pending Actions"
                          value={ParkingCount?.pending || 0}
                          active={bg === 1}
                          onClick={() => changeListStatus(1)}
                        />
                        <SwKpi
                          label="Whitelisted"
                          value={ParkingCount?.approved || 0}
                          active={bg === 3}
                          onClick={() => changeListStatus(3)}
                        />

                        <SwKpi
                          label="Rejected"
                          value={ParkingCount?.rejected || 0}
                          active={bg === 6}
                          onClick={() => changeListStatus(6)}
                        />

                        <SwKpi
                          label="Deleted"
                          value={ParkingCount?.deleted || 0}
                          active={bg === 4}
                          onClick={() => changeListStatus(4)}
                        />
                      </SwKpiGroup>
                    </div>
                  </div>
                ) : (
                  ''
                )}
                
                <div class="row">
                  <div class="col-12">
                    {ParkingUser.length > 0 && selectedLocations.length !== 0 ? (
                      <AntDTable
                          columns={columns}
                          dataSource={ParkingUser}
                          rowKey="rec_id"
                          loading={false}
                          pageSize={article.limit}
                          currentPage={PageNo}
                          totalRecords={totalRec}
                          onPageChange={(page, pageSize) => {
                            setPageNoData(page);

                            article.offset = (page - 1) * pageSize;
                            article.limit = pageSize;

                            fetchParkingData(article);
                          }}
                          onRowClick={(record) => handleRowClick(record)}
                        />
                ) : (
                  <div className='my-4'><SwNoData message="No Data available" />    </div>
                )}
                  </div>
                </div>

              </div>
              {/* </section> */}
              {/*<!-- Modal -->*/}
           <SwModal
            show={changeStatusModalOpen}
            onClose={() => setChangeStatusModalOpen(false)}
            backdrop="static"
            className='sw-small-modal'
            keyboard={false}
            footer={
              <div className="d-flex justify-content-center align-items-center gap-3">
                  <SwButton size='sm' variant='dark-outline' onClick={() => setChangeStatusModalOpen(false)}>
                    No
                  </SwButton>
                  <SwButton
                    variant='danger'
                    size='sm'
                    onClick={() => {
                      changeStatus(RequestId, RequestStatus, TagId);
                    }}
                  >
                    Yes
                  </SwButton>
                  
                </div>
              }
            >
              <SwButton variant="" className='btn-close btn-close-custom' onClick={() => setChangeStatusModalOpen(false)}></SwButton>
              <div className='text-center'>
                <h3 className='SwModalSubHeading'>Parking Request</h3>
                <p>{RequestText}</p>
              </div>
            </SwModal>

           <SwModal
            show={deleteModalOpen}
            onClose={() => setDeleteModalOpen(false)}
            backdrop="static"
            className='sw-small-modal'
            keyboard={false}
            footer={
              <div className="d-flex justify-content-center align-items-center gap-2">
              <SwButton
                size='sm'
                variant='danger'
                onClick={() => {
                  deleteParkSmart(RequestId, VehicleNumber);
                }}
              >
                Yes
              </SwButton>
              <SwButton size='sm' variant='dark-outline'  onClick={()=> setDeleteModalOpen(false)}>
                No
              </SwButton>
              </div>
            }
          >

            <SwButton variant="" className='btn-close btn-close-custom' onClick={()=> setDeleteModalOpen(false)} ></SwButton>
            <div className='text-center'>
              <h3 className='SwModalSubHeading'>Parking Request</h3>
              <p>{RequestText}</p>
            </div>
          </SwModal>

            <div
              className=" modal fade qrModel SSOWarningModal"
              id="ParkPlusAccessDenied"
              data-backdrop="static"
              data-keyboard="false"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content ">
                  <button
                    type="button"
                    className="close d-none"
                    data-dismiss="modal"
                  >
                    X
                  </button>

                  <div className="modal-body">
                    <div className="ParkPlusAccessDenied-Content text-center  my-3">
                      <div className="mb-3">
                        <div className="mb-3">
                          <img src="img/access-warning-icon.svg" />
                        </div>
                        <h3>Access Restricted</h3>
                      </div>

                      <div className="pb-2">
                        <p>
                          Access to the ParkPlus dashboard is restricted.
                          Kindly reach out to your account manager for
                          additional details and assistance.
                        </p>
                      </div>

                      <div className=" mt-3">
                        <button
                          className="btn btn-danger px-5"
                          data-dismiss="modal"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </>
          ) : loaderServiceAccess == true ? (
            <>
              <SwLoader />
            </>
          ) : (
            <MarketingPanel />
          )}
          {/* Add Vehicle Modal */}
       <SwOffCanvas
          show={isVehicleDrawerOpen}
          onClose={() => setIsVehicleDrawerOpen(false)}
          title="Add Vehicle"
          placement="end"
          backdrop="static"
          keyboard={false}
          footer={
          <SwButton
            // size="sm"
            variant="primary"
            onClick={handleVehicleSubmit}
            loading={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </SwButton>
          }
        >
          <div className="">

            {/* Row 1 */}
            <div className="row">
              <div className="col-md-6">
                <div className='SwFormGroup'>
                  <label className='SwFormLabel'>Name</label>
                  <SwInput
                    value={vehicleData.name}
                    readOnly
                    disabled={true}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className='SwFormGroup'>
                  <label className='SwFormLabel'>Email id</label>
                  <SwInput
                    value={vehicleData.email}
                    readOnly
                    disabled={true}
                  />
                </div>
              </div>
            </div>

            {/* Row 2 */}
            <div className="row">
              <div className="col-md-6">
                <div className='SwFormGroup'>
                <label className='SwFormLabel'>Contact number</label>
                <SwInput
                  value={vehicleData.phone}
                  disabled={true}
                  readOnly
                />
                </div>
              </div>

              <div className="col-md-6">
                <div className='SwFormGroup'>
                  <label className='SwFormLabel'>Vehicle number</label>
                  <SwInput
                    value={vehicleData.vehicleNumber}
                    readOnly
                    disabled={true}
                  />
                </div>
              </div>
            </div>

            {/* Row 3 */}
            <div className="row">
              <div className="col-md-6">
                <div className='SwFormGroup'>
                  <label className='SwFormLabel'>Vehicle type</label>
                  <SwInput
                    value={
                      vehicleData.vehicleType === '2'
                        ? 'Two Wheeler'
                        : vehicleData.vehicleType === '4'
                        ? 'Four Wheeler'
                        : vehicleData.vehicleType
                    }
                    readOnly
                    disabled={true}
                  />
                  </div>
              </div>

              <div className="col-md-6">
                <div className='SwFormGroup'>
                  <label className='SwFormLabel'>
                    Tag RFID{' '}
                    {vehicleData.vehicleType === '2' && (
                      <span className='Required'>*</span>
                    )}
                  </label>

                  <SwSelect
                    value={
                      tagOptions.find(
                        option => option.value === vehicleData.rfidTag
                      ) || null
                    }
                    onChange={selected =>
                      setVehicleData({
                        ...vehicleData,
                        rfidTag: selected?.value,
                        tagId: selected?.tagId,
                      })
                    }
                    options={tagOptions}
                    components={{
                      DropdownIndicator: SwSelectArrow,
                      ClearIndicator: SwClearIndicator,
                      IndicatorSeparator: () => null,
                    }}
                    placeholder="Select Tag ID"
                    isClearable={false}
                  />
                </div>
              </div>
            </div>

          </div>
        </SwOffCanvas>

        </Layout>
      </Layout>
    </>
  );
}

export default ParkSmart;
